import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { get, map, isEmpty, sum, forEach } from "lodash";
import FileSaver from "file-saver";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";

import Loader from "../Common/Loader";
import DatePicker from "../Common/DatePicker";
import CustomButton from "../Common/CustomButton";
import TableCellStyled from "../Common/TableCellStyled";

import { setBreadcrumb } from "../../actions/common";
import { fetchPost } from "../../api/fetch";

import colors from "../../assets/style/colors";
import { nowWithOutSeconds } from "../../utils/date";
import DownloadIcon from "../Common/DownloadIcon";

const styles = {
  headerCell: {
    borderRight: "3px solid white",
    backgroundColor: colors.cardTitleBg,
    color: colors.black87,
    fontWeight: 500,
    height: "50px",
  },
  exportLink: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const Stats3 = (props) => {
  const { classes, dispatch } = props;
  const [stats, setStats] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [formValues, setFormValues] = React.useState({
    startDate: nowWithOutSeconds() - 86400000,
    endDate: nowWithOutSeconds(),
  });

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([{ name: I18n.get("topbar_mspMonthlyTransactionalStats") }])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field, value) => {
    setFormValues(
      update(formValues, {
        [field]: { $set: new Date(value).getTime() },
      })
    );
  };

  const handleSearch = async () => {
    try {
      setStats({});
      setLoading(true);
      let body = {
        start: formValues.startDate,
        end: formValues.endDate,
      };

      let mdc = await fetchPost("/system/statistics/mdc", body);

      let hsp = await fetchPost("/system/statistics/hsp", body);

      console.log({
        mdc,
        hsp,
      });
      setStats({
        mdc,
        hsp,
      });
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
      setError(
        "The request to the database failed. If the specified period is too large, the API can't return all the requested data and fails. Try specifying a shorter period."
      );
    }
  };

  const exportToCsv = () => {
    let csv = `${I18n.get(`stats_mdcIteractionPoints`)};;;;\r\n`;
    csv += `${I18n.get("dashboard_company")};${I18n.get(
      "common_site"
    )};${I18n.get("stats_entrance")};${I18n.get("stats_exit")};${I18n.get(
      "stats_total"
    )}\r\n`;

    forEach(get(stats, ["mdc", "MDC - Iteraction Points"]), (item) => {
      csv += `${get(item, ["company_name"])};${get(item, [
        "site_name",
      ])};${get(item, ["entrance"])};${get(item, ["exit"])};${get(item, [
        "total",
      ])}\r\n`;
    });
    csv += `;;${sum(
      map(get(stats, ["mdc", "MDC - Iteraction Points"]), (item) =>
        get(item, ["entrance"])
      )
    )};${sum(
      map(get(stats, ["mdc", "MDC - Iteraction Points"]), (item) =>
        get(item, ["exit"])
      )
    )};${sum(
      map(get(stats, ["mdc", "MDC - Iteraction Points"]), (item) =>
        get(item, ["total"])
      )
    )}\r\n\n`;

    csv += `${I18n.get(`stats_hspIteractionPoints`)};;;;\r\n`;
    csv += `${I18n.get("dashboard_company")};${I18n.get(
      "common_site"
    )};${I18n.get("stats_online")};${I18n.get("stats_kiosk")};${I18n.get(
      "stats_total"
    )}\r\n`;
    forEach(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) => {
      csv += `${get(item, ["company_name"])};${get(item, [
        "site_name",
      ])};${get(item, ["online"])};${get(item, ["kiosk"])};${
        get(item, ["online"]) + get(item, ["kiosk"])
      }\r\n`;
    });
    csv += `;;${sum(
      map(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) =>
        get(item, ["online"])
      )
    )};${sum(
      map(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) =>
        get(item, ["kiosk"])
      )
    )};${
      sum(
        map(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) =>
          get(item, ["online"])
        )
      ) +
      sum(
        map(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) =>
          get(item, ["kiosk"])
        )
      )
    }\r\n`;

    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, "data.csv");

    // console.log(csv);
    // csv += map(
    //   get(stats, ["mdc", "MDC - Iteraction Points"]),
    //   (item) => `
    //             ${get(item, ["company_name"])};
    //             ${get(item, ["site_name"])};
    //             ${get(item, ["entrance"])};
    //             ${get(item, ["exit"])};
    //             ${get(item, ["total"])}
    // `
    // );
    // console.log(csv);
    // let encodedUri = encodeURI(csv);
    // let link = document.createElement("a");
    // link.setAttribute("href", encodedUri);
    // link.setAttribute("download", "stats3.csv");
    // document.body.appendChild(link); // Required for FF
    // link.click(); // This will download the data file named "my_data.csv".
  };

  const renderMdc = () => {
    return (
      <Table style={{ maxWidth: "900px" }}>
        <TableHead>
          <TableRow>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("dashboard_company")}
            </TableCellStyled>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("common_site")}
            </TableCellStyled>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("stats_entrance")}
            </TableCellStyled>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("stats_exit")}
            </TableCellStyled>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("stats_total")}
            </TableCellStyled>
          </TableRow>
        </TableHead>
        <TableBody>
          {map(
            get(stats, ["mdc", "MDC - Iteraction Points"]),
            (item, index) => (
              <TableRow
                key={index}
                style={{
                  backgroundColor:
                    index % 2 === 1 ? colors.tableDarkBg : colors.white,
                }}
              >
                <TableCellStyled>{get(item, ["company_name"])}</TableCellStyled>
                <TableCellStyled>{get(item, ["site_name"])}</TableCellStyled>
                <TableCellStyled>{get(item, ["entrance"])}</TableCellStyled>
                <TableCellStyled>{get(item, ["exit"])}</TableCellStyled>
                <TableCellStyled className="bold-500">
                  {get(item, ["total"])}
                </TableCellStyled>
              </TableRow>
            )
          )}
          <TableRow style={{ borderTop: `1px solid ${colors.veryLighPink}` }}>
            <TableCellStyled colSpan={2} />
            <TableCellStyled className="bold-500">
              {sum(
                map(get(stats, ["mdc", "MDC - Iteraction Points"]), (item) =>
                  get(item, ["entrance"])
                )
              )}
            </TableCellStyled>
            <TableCellStyled className="bold-500">
              {sum(
                map(get(stats, ["mdc", "MDC - Iteraction Points"]), (item) =>
                  get(item, ["exit"])
                )
              )}
            </TableCellStyled>
            <TableCellStyled className="bold-500">
              {sum(
                map(get(stats, ["mdc", "MDC - Iteraction Points"]), (item) =>
                  get(item, ["total"])
                )
              )}
            </TableCellStyled>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  const renderHsp = () => {
    return (
      <Table style={{ maxWidth: "900px" }}>
        <TableHead>
          <TableRow>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("dashboard_company")}
            </TableCellStyled>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("common_site")}
            </TableCellStyled>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("stats_online")}
            </TableCellStyled>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("stats_kiosk")}
            </TableCellStyled>
            <TableCellStyled className={classes.headerCell}>
              {I18n.get("stats_total")}
            </TableCellStyled>
          </TableRow>
        </TableHead>
        <TableBody>
          {map(
            get(stats, ["hsp", "HSP - Iteraction Points"]),
            (item, index) => (
              <TableRow
                key={index}
                style={{
                  backgroundColor:
                    index % 2 === 1 ? colors.tableDarkBg : colors.white,
                }}
              >
                <TableCellStyled>{get(item, ["company_name"])}</TableCellStyled>
                <TableCellStyled>{get(item, ["site_name"])}</TableCellStyled>
                <TableCellStyled>{get(item, ["online"])}</TableCellStyled>
                <TableCellStyled>{get(item, ["kiosk"])}</TableCellStyled>
                <TableCellStyled className="bold-500">
                  {get(item, ["online"]) + get(item, ["kiosk"])}
                </TableCellStyled>
              </TableRow>
            )
          )}
          <TableRow style={{ borderTop: `1px solid ${colors.veryLighPink}` }}>
            <TableCellStyled colSpan={2} />
            <TableCellStyled className="bold-500">
              {sum(
                map(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) =>
                  get(item, ["online"])
                )
              )}
            </TableCellStyled>
            <TableCellStyled className="bold-500">
              {sum(
                map(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) =>
                  get(item, ["kiosk"])
                )
              )}
            </TableCellStyled>
            <TableCellStyled className="bold-500">
              {sum(
                map(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) =>
                  get(item, ["online"])
                )
              ) +
                sum(
                  map(get(stats, ["hsp", "HSP - Iteraction Points"]), (item) =>
                    get(item, ["kiosk"])
                  )
                )}
            </TableCellStyled>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  return (
    <Box className="mainContainer">
      <Grid
        container
        direction="column"
        className="mainContent"
        wrap="nowrap"
        style={{
          padding: "12px",
          maxWidth: "1920px",
          height: "calc(100vh - 148px)",
          overflow: "auto",
        }}
      >
        <Grid item style={{ marginTop: "20px" }}>
          <Grid container justify="center">
            <Grid item style={{ maxWidth: "300px", marginRight: "24px" }}>
              <DatePicker
                label={I18n.get("site_startDate")}
                name="startDate"
                value={formValues.startDate}
                onChange={handleChange}
              />
            </Grid>
            <Grid item style={{ maxWidth: "300px" }}>
              <DatePicker
                label={I18n.get("site_endDate")}
                name="endDate"
                value={formValues.endDate}
                onChange={handleChange}
              />
            </Grid>
            <Grid
              item
              style={{
                marginLeft: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CustomButton
                variant="contained"
                color="primary"
                style={{ margin: 0 }}
                onClick={handleSearch}
              >
                {I18n.get("site_search")}
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
        {loading && (
          <Grid item xs>
            <Loader width="100%" height="100%" noDecoration />
          </Grid>
        )}
        {error && (
          <Grid item xs>
            {error}
          </Grid>
        )}
        {stats && !isEmpty(stats) && (
          <>
            <Box style={{ textAlign: "right" }}>
              <DownloadIcon exportCsv={exportToCsv} />
            </Box>
            <Box
              className="bold-500"
              style={{
                margin: "0px 0px 20px",
                padding: "10px",
                borderBottom: "1px solid " + colors.veryLighPink,
              }}
            >
              {I18n.get(`stats_mdcIteractionPoints`)}
            </Box>
            {renderMdc()}
            <Box
              className="bold-500"
              style={{
                margin: "50px 0px 20px",
                padding: "10px",
                borderBottom: "1px solid " + colors.veryLighPink,
              }}
            >
              {I18n.get(`stats_hspIteractionPoints`)}
            </Box>
            {renderHsp()}
          </>
        )}
      </Grid>
    </Box>
  );
};

export default withStyles(styles)(connect()(Stats3));
